/**
 * Esse Alert abstrai a modelagem padrão do SwalAlert
 * Este objeto é importado para o window e bara utilizar basta chamar Alerts.metodo()
 * O retorno é uma promise e pode ser recuperado com async/await ou .then() comum
 */
export default {
  question: (title, cancelText, confirmText)  => {
      return new Promise (
        async function (resolve, reject) {    
          const swal = await Swal.fire( {
            ...objSwal.question,
            cancelButtonColor: '#6c757d',
            confirmButtonColor: '#ed0909',
            title,
            cancelButtonText: cancelText || 'Voltar',
            confirmButtonText: confirmText || 'Confirmar',
          })
          if (swal.value === true) {
            resolve(true)
          }
          return false
      })
  },
  info: (title, text)  => {
    return new Promise (
      async function (resolve, reject) {    
        const swal = await Swal.fire({
          ...objSwal.info,
          title,
          text
        })
        if (swal === true) {
          resolve(true)
        }
        return false
    })
}
}